module.exports = __webpack_public_path__ + "assets/img/TrendingNow_Prototype.7b162470-ps.jpg";